import { Router } from '@angular/router';
import { Injectable, OnDestroy, Inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpClient,
} from '@angular/common/http';
import { Observable, throwError, Subject } from 'rxjs';
import { TokenService } from '../services/token.service';
import { environment } from '../../../environments/environment';
import { catchError, takeUntil } from 'rxjs/operators';

export const WebClient = 'WebClient';
export const Dashboard = 'Dashboard';
export const Tiresia = 'Tiresia';
export const Files = 'Files';
export const PDF = 'PDF';
export const GrantClient = 'GrantClient';

@Injectable()
export class TokenInterceptor implements HttpInterceptor, OnDestroy {
  protected ngUnsubscribe: Subject<void> = new Subject<void>();

  token: string;
  intentos = 0;

  constructor(private tokenService: TokenService, private _http: HttpClient) {}

  ngOnDestroy(): void {
    // This aborts all HTTP requests.
    this.ngUnsubscribe.next();
    // This completes the subject properlly.
    this.ngUnsubscribe.complete();
  }

  /**
   * Trae el token del localstorage
   */
  getToken() {
    return this.tokenService.getToken();
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Asignación del token
    this.token = this.getToken();

    if (request.headers.has(WebClient)) {
      // console.log('Estoy usando los headers webclient');
      /**
       * Headers para el sitio web
       */
      return next
        .handle(
          request.clone({
            setHeaders: {
              'Cache-Control': 'no-cache',
              Pragma: 'no-cache',
              GrantClient: environment._grantClient,
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          })
        )
        .pipe(
          catchError((error: HttpErrorResponse) => {
            // Con auth
            if (this.intentos == 0) {
              // this.envioErrorConAuth(error);
            }
            this.intentos++;
            return throwError(error);
          })
        );
    } else if (request.headers.has(Dashboard)) {
      // console.log('Estoy usando los headers dashboard');
      /**
       * Dashboard (Cliente, Proveedor, Compra, Bodega)
       */
      request = request.clone({
        setHeaders: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Authorization: 'Bearer ' + this.token,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });

      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          // Con auth
          if (this.intentos == 0) {
            // this.envioErrorConAuth(error);
          }
          this.intentos++;
          return throwError(error);
        })
      );
    } else if (request.headers.has(Tiresia)) {
      /**
       * Tiresia
       */
      // console.log('Usando headers tiresia');
      request = request.clone({
        setHeaders: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Authorization: 'Bearer ' + this.token,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });

      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          // Con auth
          if (this.intentos == 0) {
            // this.envioErrorConAuth(error);
          }
          this.intentos++;
          return throwError(error);
        })
      );
    } else if (request.headers.has(Files)) {
      /**
       * Files
       */
      // console.log('Usando headers Files');
      request = request.clone({
        setHeaders: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Authorization: 'Bearer ' + this.token,
        },
      });

      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          // Con auth
          if (this.intentos == 0) {
            // this.envioErrorConAuth(error);
          }
          this.intentos++;
          return throwError(error);
        })
      );
    } else if (request.headers.has(PDF)) {
      /**
       * PDF BLOB
       * Headers para descargar los PDF
       */
      // console.log('Usando headers PDF');
      request = request.clone({
        setHeaders: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Authorization: 'Bearer ' + this.token,
          'Content-Type': 'application/pdf',
        },
      });

      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          // Con auth
          if (this.intentos == 0) {
            // this.envioErrorConAuth(error);
          }
          this.intentos++;
          return throwError(error);
        })
      );
    } else if (request.headers.has(GrantClient)) {
      /**
       * GrantClient
       */
      // console.log('Usando headers GrantClient');
      request = request.clone({
        setHeaders: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Authorization: 'Bearer ' + this.token,
          GrantClient: 'HtVlCdYlRJuMWOgEtJtGN2NMIYmnP4u8GeyGz1sU',
          'Content-Type': 'application/pdf',
        },
      });

      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          // Con auth
          if (this.intentos == 0) {
            // this.envioErrorConAuth(error);
          }
          this.intentos++;
          return throwError(error);
        })
      );
    } else {
      /**
       * Lo que no tenga header aplicado
       *
       */
      // console.log('Usando headers defecto');
      request = request.clone({
        setHeaders: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });

      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          // Sin auth
          if (this.intentos == 0) {
            this.envioErrorSinAuth(error);
          }
          this.intentos++;
          return throwError(error);
        })
      );
    }
  }

  /**
   * Envía los errores a la base de datos cuando hay un usuario loggeado
   * @param error HTTP Error
   */
  // async envioErrorConAuth(error) {
  //   const body = {
  //     header: JSON.stringify(error.headers),
  //     body_error: JSON.stringify(error),
  //   };
  //   if (error.status == 0) {
  //     // Logout
  //     await this._http
  //       .post(environment.login_logout, {
  //         headers: {
  //           'Cache-Control': 'no-cache',
  //           Pragma: 'no-cache',
  //           GrantClient: environment._grantClient,
  //           Authorization: 'Bearer ' + this.token,
  //           Accept: 'application/json',
  //           'Content-Type': 'application/json',
  //         },
  //       })
  //       .toPromise()
  //       .then((data) => {
  //         console.log(data);
  //         this.router.navigate(['']);
  //         localStorage.clear();
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         this.router.navigate(['']);
  //         localStorage.clear();
  //       });
  //   } else if (error.status !== 401) {
  //     await this._http
  //       .post(environment.error.envioConToken, body)
  //       .pipe(takeUntil(this.ngUnsubscribe))
  //       .subscribe((res) => {
  //         // console.log(res);
  //       });
  //   }
  // }
  /**
   * Envía el error en áreas donde no se esté utilizando token
   * o que los headers no posean nombre alguno
   * @param error HTTP Error
   */
  async envioErrorSinAuth(error) {
    const body = {
      header: JSON.stringify(error.headers),
      body_error: JSON.stringify(error),
    };

    if (error.status !== 401) {
      await this._http
        .post(environment.error.envioSinToken, body)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res) => console.log(res));
    }
  }
}
